export const isStep1Valid = (form) => !!form.loan_amount;

export const isStep2Valid = (form) =>
  !!form.loan_purpose && !!form.trading_time && !!form.annual_turnover.trim() && !!form.monthly_sales.trim() && !!form.homeowner;

export const isStep3Valid = (form) =>
  !!form.full_name && !!form.business_name && /\S+@\S+\.\S+/.test(form.email) && form.phone.length >= 7;

const STEP_VALIDATORS = [isStep1Valid, isStep2Valid, isStep3Valid];

export const isStepValid = (step, form) => {
  const validator = STEP_VALIDATORS[step];
  return validator ? validator(form) : true;
};
